import bitacora from "@/locales/languages/es_MX/view/bitacoras/bitacora";
import monitorCorreos from "@/locales/languages/es_MX/view/bitacoras/monitorCorreos";
import reporteAuditoria from "@/locales/languages/es_MX/view/bitacoras/reporteAuditoria";
import geolocalizacion from "@/locales/languages/es_MX/view/bitacoras/geolocalizacion";

export default {
  bitacora
  , monitorCorreos
  , reporteAuditoria
  , geolocalizacion
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/bitacoras/index.js